module.exports = __webpack_public_path__ + "img/teacher.553029d4.gif";